import React, { useContext, useCallback } from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import createStyles from '@material-ui/core/styles/createStyles';
import { Theme } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

import { ArchivalAidMetadata, EadNode } from 'types';
import { GridActionButtonComponent } from 'components/grid/grid-types';
import { DialogContext } from 'components/dialog/dialog-context';
import { BasicQuoteDialog } from 'components/dialog/aisuk-dialogs/aisuk-basic-quote-dialog';

import { generateEadQuote } from './utils/generate-ead-quote';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    navigationButton: {
      marginTop: theme.spacing(),
      alignSelf: 'baseline',
      width: '100%',
    },
  })
);

export function EadQuote({ item, rootArchivalAid }: GridActionButtonComponent) {
  const classes = useStyles();
  const { open } = useContext(DialogContext);

  const eadNode = item as EadNode;
  const archivalAidMetadata = rootArchivalAid as
    | ArchivalAidMetadata
    | undefined;

  const handleOpenQuoteDialog = useCallback(() => {
    open({
      initialValues: {
        quoteContent: generateEadQuote({ archivalAidMetadata, eadNode }),
      },
      size: 'sm',
      Content: BasicQuoteDialog,
    });
  }, [archivalAidMetadata, eadNode, open]);

  return (
    <>
      <Button
        component="span"
        variant="outlined"
        color="primary"
        className={classes.navigationButton}
        onClick={handleOpenQuoteDialog}
      >
        Vytvoř citaci
      </Button>
    </>
  );
}
